import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import {
  feesCard,
  feesSideSection
} from '../componentSections/detailsFeesComponents';
import {
  fireDetailsPageComponentFailureFpti,
  parseData
} from '../../../lib/helpers';
import { useFptiImpression } from '../../../lib/hooks';

const DetailsFees = ({
  componentContent = {},
  fptiImpression,
  handleClickFPTI
}) => {
  const { subtitleLink, subtitle, title, fees } = componentContent;
  const ref = useRef();
  useFptiImpression(ref, () => {
    fptiImpression({
      pageLink: 'fees'
    });
  });

  if (!fees) {
    fireDetailsPageComponentFailureFpti({
      data: { fees },
      componentName: 'DetailsFees',
      fptiImpression
    });
    return null;
  }

  const parsedFees = parseData(fees);
  const showFeesSideSection = Boolean(title);

  return (
    <section id="details-fees">
      <div
        className={`details-fees-container${
          showFeesSideSection ? ' with-side-section' : ''
        }`}
        ref={ref}
      >
        {feesCard(parsedFees, handleClickFPTI, showFeesSideSection)}
        {showFeesSideSection &&
          feesSideSection({
            subtitleLink,
            subtitle,
            title,
            handleClickFPTI
          })}
      </div>
    </section>
  );
};

DetailsFees.propTypes = {
  componentContent: PropTypes.object,
  cardTitle: PropTypes.string,
  cardFooterText: PropTypes.string,
  feeSideLinkText: PropTypes.string,
  feeSideSubtitle: PropTypes.string,
  feeSideTitle: PropTypes.string,
  fptiImpression: PropTypes.func.isRequired,
  feeSubtext: PropTypes.string,
  feeSideLinkUrl: PropTypes.string,
  fee: PropTypes.string,
  featureItem: PropTypes.object,
  handleClickFPTI: PropTypes.func,
  feeSideFPTI: PropTypes.string
};

export default DetailsFees;
